export const passInfo = {
  salt: 'p9Tkr6uqxKtf',
  algorithm: 'pbkdf2_sha256',
  iterations: 180000,
};
